module.exports = __webpack_public_path__ + "img/myguard_pro_banner_03.47159f12.jpg";